import { render } from "./ozon.svg?vue&type=template&id=7a8fabfb"
const script = {}
script.render = render

export default script